import { useState } from "react";
import { Capacitor } from "@capacitor/core";
import { LoginToken } from "../Utility/common";
import { Link } from "react-router-dom";
import config from "../../config";
import { FaInstagram, FaLink, FaTiktok, FaYoutube } from "react-icons/fa";
import { Preferences } from "@capacitor/preferences";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  InputGroup,
  Label,
} from "reactstrap";
import Cookies from "js-cookie";
import Loader from "react-loader-spinner";
import { AvForm, AvField, AvGroup } from "availity-reactstrap-validation";
import { MdCheckCircle, MdRemove, MdDelete } from "react-icons/md";
import { act } from "react";

const HelpWantedModal = ({
  activeCard,
  setActiveCard,
  profiles,
  isModal = true,
  logInUsername
}) => {
  const [selectedProfile, setSelectedProfile] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [file, updateFile] = useState(null);
  const [fileName, updateFileName] = useState("Upload Image");
  const [fileResult, updateFileResult] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState(null);
  const loginToken = LoginToken();
  const [formState, setFormState] = useState({});

  const toggle = () => {
    setActiveCard(null);
  };

  const handleChange = (e, fieldName, fieldID) => {
    setFormState((prev) => ({
      ...prev,
      [`EXPLORESURVEYFIELDID_${fieldID}`]: e.target.value,
    }));
  };

  const submit = async () => {
    setIsLoading(true);
    if (isFormComplete) {
      const contactDetail = Capacitor.isNativePlatform()
          ? await Preferences.get({ key: "ContactDetail" }).then(
              ({ value }) => value
            )
          : Cookies.get("ContactDetail");
      const obj = {
        ExploreSurveyID: activeCard?.ExploreSurveyID,
        EmailAddress: logInUsername,
        ExploreSurveyResponseJSON: JSON.stringify(formState),
        ContactID: JSON.parse(contactDetail)?.contactID,
        CampaignName: activeCard?.ExploreSurveyTitle_ExternalPublic,
      };

      try {
        const res = await fetch(
          `${config.genni.marketing_portal.API_KEY}/creatorapi/apply-to-help-wanted`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": loginToken,
            },
            body: JSON.stringify(obj),
          }
        );
        if (res.ok) {
          const d = await res.json();
          setSuccess(true);
        } else {
          throw res;
        }
      } catch (err) {
        console.error("fetch error:", err);
      }
    }
  };

  const returnPlatform = () => {
    if (activeCard?.PlatformID === 4) return "TikTok";
    if (activeCard?.PlatformID === 8) return "capcut";
    if (activeCard?.PlatformID === 7) return "YouTube";
    return "Instagram";
  };

  const platform = returnPlatform();
  const isFormComplete = activeCard?.fields.every((q) => {
    const value = formState[`EXPLORESURVEYFIELDID_${q.ExploreSurveyFieldID}`];
    return typeof value === "string"
      ? value.trim() !== ""
      : value !== undefined && value !== null && value !== "";
  });

  const formattedProfiles = profiles?.results?.ContactPlatforms.filter(
    (prof) => prof.Platform === platform
  );

  const Wrapper = isModal ? Modal : "div";
  const wrapperProps = isModal
    ? { isOpen: activeCard !== null, toggle }
    : { className: "p-4 border rounded bg-white" };

  return (
    <Wrapper {...wrapperProps}>
      {success ? (
        <div className="flex flex-col justify-center text-center py-4 p-3">
          <div
            className="rounded-full"
            style={{
              background: "rgb(249, 250, 251)",
              height: 68,
              width: 68,
              borderRadius: "100%",
              display: "flex",
              justifyContent: "center",
              margin: "AUTO",
              alignItems: "center",
            }}
          >
            <MdCheckCircle size={36} color="#32a852" />
          </div>
          <h4 className="mt-3 font-black">Application Received!</h4>
          <p className="mt-0 font-semibold" style={{ fontSize: "1rem" }}>
            If selected, you will receive an email and genni notification!
            Please check back regularly.
          </p>
        </div>
      ) : (
        <>
          {!Capacitor.isNativePlatform() && (
            <ModalHeader className={!isModal && "mb-3"}>
              {activeCard?.ExploreSurveyTitle_ExternalPublic} - Application
            </ModalHeader>
          )}
          
          <ModalBody>
            <Form>
              <FormGroup>
                <InputGroup
                  className="mb-0"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <AvForm className="login-form">
                    {activeCard?.fields.map((question) => {
                      if (question.FieldLabel === "What is your handle?") {
                        return (
                          <AvGroup className="form-group position-relative mb-0">
                            <Label
                              className="mt-0 mb-0"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              {platform} Handle
                            </Label>
                            <Label
                              className="custom-control-label text-muted mb-2"
                              style={{ fontSize: 12, fontWeight: 500 }}
                              for="customCheck1"
                            >
                              You may only apply with one handle at a time.
                            </Label>
                            {formattedProfiles &&
                              formattedProfiles.map((a) => (
                                <div
                                  key={a.ContactPlatformID}
                                  className="p-3 mb-2 option-button"
                                  onClick={() => {
                                    setFormState((prev) => ({
                                      ...prev,
                                      [`EXPLORESURVEYFIELDID_${question.ExploreSurveyFieldID}`]:
                                        a.ContactPlatformID,
                                    }));
                                    setSelectedProfile(a.ContactPlatformID);
                                  }}
                                >
                                  <input
                                    type="radio"
                                    checked={
                                      a.ContactPlatformID === selectedProfile
                                    }
                                  />
                                  <p className="ml-4 radio-label">{a.Handle}</p>
                                </div>
                              ))}
                          </AvGroup>
                        );
                      }
                      return (
                        <div key={question.ExploreSurveyFieldID}>
                          <AvGroup className="form-group position-relative mb-0">
                            <Label className="mt-0">
                              {question.FieldLabel}
                            </Label>
                            <AvField
                              type="text"
                              className="form-control px-2"
                              name={question.FieldName}
                              id={question.FieldName}
                              value={formState[question.FieldName] || ""}
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  question.FieldName,
                                  question.ExploreSurveyFieldID
                                )
                              }
                              required
                              style={{ fontSize: 14, paddingLeft: 4 }}
                              placeholder={question.FieldLabel}
                              errorMessage=""
                            />
                          </AvGroup>
                        </div>
                      );
                    })}
                  </AvForm>
                  <FormGroup className="mb-0">
                    <div className="custom-control custom-checkbox">
                      <Label
                        className="custom-control-label text-muted"
                        style={{ fontSize: 12, fontWeight: 500 }}
                        for="customCheck1"
                      >
                        By pressing submit, you agree to the{" "}
                        <Link
                          to="/terms"
                          className="text-muted text-decoration-underline"
                        >
                          Terms Of Services
                        </Link>{" "}
                        and understand that you may not be chosen for the
                        campaign.
                      </Label>
                    </div>
                  </FormGroup>
                </InputGroup>
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button disabled={!isFormComplete} color="pink" onClick={submit}>
              {isLoading ? (
                <Loader type="Bars" color="#fff" width={20} height={20} />
              ) : (
                "Submit"
              )}
            </Button>
          </ModalFooter>
        </>
      )}
    </Wrapper>
  );
};

export default HelpWantedModal;
